<div class="card mb-0">
  <div class="card-body mb-0 py-0">
    <div class="mb-2">
      <strong>PEACEPLUS: EQUALITY DATA MONITORING FORM (DRAFT)63</strong>
      <div>
        We need your help so we can monitor and evaluate the Programme you are
        participating in.
      </div>
    </div>

    <div class="mb-2">
      <strong>What are we collecting?</strong>
      <div>Sensitive personal data.</div>
    </div>

    <div class="mb-2">
      <strong>Why are we collecting this data?</strong>
      <div>
        To measure and evidence the reach and impact of the PEACEPLUS Programme.
      </div>
      <div>
        To monitor programme implementation and inform policy decisions.
      </div>
      <div>To ensure compliance with our legal obligations.</div>
    </div>

    <div class="mb-2">
      <strong>What are we using it for?</strong>
      <div>Your feedback will:</div>
      <div>
        Make sure equality and good relations are at the heart of the Programme.
      </div>
      <div>
        Allow us to better design, adapt, monitor, and evaluate our
        projects/Programme.
      </div>
      <div>
        Help tackle inequalities, sectarianism, racism, and social exclusion.
      </div>
      <div>
        To incorporate supports that address the barriers to participation.
      </div>
    </div>
  </div>
</div>
